export default __webpack_public_path__ + "static/media/loupe.639f505c.png";